import { Typography } from "@mui/material";
import classNames from "classnames";

import { Container } from "../Container/Container";

import "./not_found.scss";

export type TNotFoundProps = {
	text: string;
	white?: boolean;
};

export function NotFound({ text, white = false }: TNotFoundProps) {
	return (
		<Container
			navbarOrkaProps={{ white }}
			className={classNames("not-found-container", { white })}>
			<Typography className="not-found-text">{text}</Typography>
		</Container>
	);
}
